<template>
  <v-row align="center" justify="center" justify-md="start" class="mb-1">
    <v-img :src="cardBrand" max-height="20" max-width="35" alt="img" contain />
    <div class="small-label">
      {{ cardNumber }}
    </div>
  </v-row>
</template>

<script>
  import visa from "payment-icons/min/flat/visa.svg";
  import amex from "payment-icons/min/flat/amex.svg";
  import defaultIcon from "payment-icons/min/flat/default.svg";
  import diners from "payment-icons/min/flat/diners.svg";
  import discover from "payment-icons/min/flat/discover.svg";
  import elo from "payment-icons/min/flat/elo.svg";
  import hipercard from "payment-icons/min/flat/hipercard.svg";
  import jcb from "payment-icons/min/flat/jcb.svg";
  import maestro from "payment-icons/min/flat/maestro.svg";
  import mastercard from "payment-icons/min/flat/mastercard.svg";

  export default {
    name: "PaymentCardField",
    props: {
      card: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        brands: {
          defaultIcon: defaultIcon,
          visa: visa,
          americanexpress: amex,
          dinersclub: diners,
          discover: discover,
          jcb: jcb,
          mastercard: mastercard,
          elo: elo,
          hipercard: hipercard,
          maestro: maestro,
        },
      };
    },
    computed: {
      cardBrand() {
        if (this.card && this.card.brand) {
          let formattedBrand = this.card.brand.replace(/\s+/g, "").toLowerCase();
          return this.$_.has(this.brands, formattedBrand) ? this.brands[formattedBrand] : this.brands.defaultIcon;
        } else {
          return this.brands.defaultIcon;
        }
      },
      cardNumber() {
        return this.card && this.card.last4 ? `************${this.card.last4}` : null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Payment/PaymentCardField.vue